import { keepPreviousData, useQuery } from "@tanstack/react-query";
import fetch from "logic/rest/FetchProvider";
import { qualifyUrl } from "util/URLUtils";
import { defaultOnError } from "util/conditional/onError";
const INITIAL_DATA = {
  customFieldMappings: [],
  name: null,
  id: null,
  description: null,
  indexSetIds: []
};
const fetchIndexSetFieldTypeProfile = async (id) => {
  const url = qualifyUrl(`/system/indices/index_sets/profiles/${id}`);
  return fetch("GET", url).then((profile) => ({
    id: profile.id,
    name: profile.name,
    description: profile.description,
    customFieldMappings: profile.custom_field_mappings,
    indexSetIds: profile.index_set_ids
  }));
};
const useProfile = (id) => {
  const { data, isFetched, isFetching, refetch } = useQuery({
    queryKey: ["indexSetFieldTypeProfile", id],
    queryFn: () => defaultOnError(
      fetchIndexSetFieldTypeProfile(id),
      "Loading index field type profile failed with status",
      "Could not load index field type profile"
    ),
    placeholderData: keepPreviousData,
    enabled: !!id
  });
  return {
    data: data != null ? data : INITIAL_DATA,
    isFetched,
    isFetching,
    refetch
  };
};
export default useProfile;
